export enum CommerceStatus {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
}

export const COMMERCE_STATUS_LABELS = {
  [CommerceStatus.CREATED]: 'Creado',
  [CommerceStatus.ACTIVE]: 'Activo',
} as const;
